/**
 * Kogui
 * Kogui App
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Define el estado del evento
 */
export type EstadoEvento = 'ACTIVO' | 'CANCELADO' | 'COMPLETO' | 'FINALIZADO' | 'BORRADOR';

export const EstadoEvento = {
    ACTIVO: 'ACTIVO' as EstadoEvento,
    CANCELADO: 'CANCELADO' as EstadoEvento,
    COMPLETO: 'COMPLETO' as EstadoEvento,
    FINALIZADO: 'FINALIZADO' as EstadoEvento,
    BORRADOR: 'BORRADOR' as EstadoEvento
};

